// extracted by mini-css-extract-plugin
export default {"editNameDiv":"EditName_editNameDiv__MsyyE","styledInput":"EditName_styledInput__eum87","userEmail":"EditName_userEmail__H-7Cr"};